<template>
	<div class="mainWrapper po">
		<h1>Purchase Order Detail</h1>
		<div class="po-details" v-if="po">
			<div class="first-row">
				<div class="details"><span>PO NUMBER</span> <br />{{ po.purchase_order.code }}</div>
				<div class="details">
					<span>LOCATION</span> <br />
					{{ po.purchase_order.shop && po.purchase_order.shop.name ? po.purchase_order.shop.name : po.purchase_order.warehouse.name }}
				</div>
				<div class="details">
					<span>BRAND</span> <br />
					{{ po.purchase_order.brand.name }}
				</div>
				<div class="details">
					<span>REQUESTED BY</span> <br />
					{{ po.purchase_order.author.name }}
				</div>
				<div class="details">
					<span>CREATED</span> <br />
					{{ convertTime(po.purchase_order.createdAt) }}
				</div>
			</div>

			<div class="list">
				<div class="poItemList header">
					<div>BD CODE</div>
					<div>BARCODE</div>
					<div>PRODUCT NAME</div>
					<div>REQUESTED QUANTITY</div>

					<div>EXPECTED DATE</div>
				</div>

				<div v-for="(item, index) of po.purchase_order_items" v-bind:key="index" class="poItemList">
					<div>{{ item.product.bd_code }}</div>
					<div>{{ item.product.barcode }}</div>
					<div>{{ item.product.name }}</div>
					<div>
						{{ item.qty }} <span class="unit">{{ item.packaging_selection ? item.packaging_selection : 'single_item' }}</span>
					</div>

					<div>{{ convertTime(item.expected_date) }}</div>
				</div>
			</div>

			<div class="po-detail-buttons-wrapper">
				<div class="align-left">
					<b-button type="is-dark" icon-left="arrow-left" @click="back()">BACK</b-button>
				</div>
				<div class="align-right">
					<button class="big-button" v-if="po.purchase_order.status" @click="createPI()">
						CREATE PURCHASE INVOICE
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'PurchaseOrderDetails',
	data: function() {
		return {
			poId: this.$route.params.id, //id from get url
			po: null // PO details
		}
	},
	mounted: async function() {
		var data = {
			id: this.poId,
			populate_purchase_order: ['author', 'supplier', 'shop', 'brand', 'warehouse'],
			populate_purchase_order_item: ['product']
		}

		const apiGetPO = await this.$api.getPODetail({ data })

		this.po = apiGetPO.data
	},
	methods: {
		createPI: function() {
			// this.$router.push("/pi/view/" + this.poId);
			const id = this.poId
			this.$router.push({ name: 'createPi', params: { id } })
		},
		back: function() {
			this.$router.go(-1)
		},
		// Convert time
		convertTime: function(time) {
			return this.$moment(time).format('DD/MM/YY')
		}
	}
}
</script>

<style scoped>
@import '../styles/POView.css';
</style>
